module.exports.getIP = function () {
    return "https://mtfs.noksoft.co.th/"
}

module.exports.getImagePath = function () {
    return "https://mtfs.noksoft.co.th/"
}